import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@material-ui/core'
import { AxiosError } from 'axios'
import React from 'react'
import { useMutation } from 'react-query'
import { setApiErrors } from 'src/forms/errors'
import { skuit } from 'src/services/skuit'
import * as yup from 'yup'

import { handleErrorMessage, sendAlert } from 'src/snackbar'
import { useForm } from '../../../forms'

interface PalletIdProps {
  client_uid: string
}

const palletIdSchema = yup.object().shape({
  client_uid: yup.string().label('Client Id').required(),
})
interface Props {
  open: boolean
  handleClose: () => void
  onSuccess?: () => void
  palletGuid?: string
}

export const PalletIdDialog = (props: Props) => {
  const { open, handleClose, onSuccess, palletGuid } = props

  const { Form, Field, data: formData } = useForm(palletIdSchema)

  const { mutate: updatePallet } = useMutation(skuit.sc.pallets.patch, {
    onSuccess: (updatedPallet) => {
      sendAlert({
        severity: 'success',
        message: `Successfully updated pallet client id: ${updatedPallet.name}!`,
      })

      onSuccess?.()
    },
    onError: (error: AxiosError) => {
      handleErrorMessage(error, 'updat', 'Pallet')
      setApiErrors(formData.setError, error)
    },
  })

  const onSubmit = (data: PalletIdProps) => {
    updatePallet({ guid: palletGuid || '', data })
    handleClose()
  }

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Pallet</DialogTitle>
      <Form onSubmit={onSubmit}>
        <DialogContent>
          <Field
            name="client_uid"
            renderField={({ name, value, setValue, error }) => (
              <TextField
                id={name}
                name={name}
                label="Client Id"
                error={!!error}
                helperText={error}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  setValue(name, e.target.value)
                }
                value={value || ''}
              />
            )}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button type="submit" color="primary" autoFocus>
            Save
          </Button>
        </DialogActions>
      </Form>
    </Dialog>
  )
}
